/* Mobile installation timeline. Decorative progress never changes the order flow. */
(function(w){
  'use strict';
  w.COProductRouteMotion=function(section){
    const narrow=w.matchMedia('(max-width:700px)'),reduced=w.matchMedia('(prefers-reduced-motion: reduce)');
    const items=[...section.querySelectorAll('[data-next-route] li')];
    const routes=[...section.querySelectorAll('[data-next-route]')];
    const off=[],visible=new Set();let frame=0,dead=false;
    const on=(el,name,fn,options)=>{el.addEventListener(name,fn,options);off.push(()=>el.removeEventListener(name,fn,options));};
    function clear(){
      section.classList.remove('has-mobile-route-motion');
      items.forEach(item=>{item.style.removeProperty('--route-progress');item.querySelector('[data-next-node]')?.classList.remove('is-reached');});
    }
    function paint(){
      frame=0;if(dead||document.hidden||!narrow.matches)return;
      if(observer&&!visible.size)return;
      const viewport=w.visualViewport?.height||w.innerHeight;
      const header=document.querySelector('.site-header')?.getBoundingClientRect();
      const top=Math.max(0,Math.min(viewport*.25,header?.bottom||0));
      let bottom=viewport;
      document.querySelectorAll('.p30-buybar:not(.is-at-hero),#preview-bar-iframe').forEach(el=>{
        const r=el.getBoundingClientRect();
        if(r.height&&r.top>top&&r.top<bottom&&getComputedStyle(el).visibility!=='hidden')bottom=r.top;
      });
      const cut=top+(bottom-top)*.72;
      // Read all geometry before applying styles; the moving light only scales a line.
      const states=items.map(item=>{
        const r=item.getBoundingClientRect(),node=item.querySelector('[data-next-node]');
        const nr=node?.getBoundingClientRect();
        return {item,node,reached:reduced.matches||cut>=(nr?nr.top+nr.height/2:r.top),progress:reduced.matches?1:Math.max(0,Math.min(1,(cut-r.top-42)/Math.max(1,r.height-24)))};
      });
      section.classList.add('has-mobile-route-motion');
      states.forEach(({item,node,reached,progress})=>{
        item.style.setProperty('--route-progress',progress.toFixed(4));
        node?.classList.toggle('is-reached',reached);
      });
    }
    function schedule(){if(!dead&&narrow.matches&&!frame&&!document.hidden)frame=w.requestAnimationFrame(paint);}
    const observer=w.IntersectionObserver?new IntersectionObserver(entries=>{
      entries.forEach(e=>{if(e.isIntersecting)visible.add(e.target);else visible.delete(e.target);});schedule();
    },{rootMargin:'80px 0px'}):null;
    routes.forEach(route=>observer?.observe(route));
    const resize=w.ResizeObserver?new ResizeObserver(schedule):null;
    routes.forEach(route=>resize?.observe(route));
    on(w,'scroll',()=>{if(!observer||visible.size)schedule();},{passive:true});
    on(w,'resize',schedule,{passive:true});
    if(w.visualViewport)on(w.visualViewport,'resize',schedule,{passive:true});
    on(document,'visibilitychange',schedule);
    on(narrow,'change',()=>{if(!narrow.matches)clear();else schedule();});
    on(reduced,'change',schedule);
    schedule();
    return()=>{dead=true;w.cancelAnimationFrame(frame);observer?.disconnect();resize?.disconnect();off.forEach(fn=>fn());clear();};
  };
})(window);
